import type { SVGProps } from "react";
import * as React from "react";

const SvgBatteryCharging = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5 19a1 1 0 1 0 0-2zm-4-3H0zM3 6V5zm3.19 1a1 1 0 0 0 0-2zM15 5a1 1 0 1 0 0 2zm2 1V5zm-3.19 11a1 1 0 1 0 0 2zM22 13a1 1 0 1 0 2 0zm2-2a1 1 0 1 0-2 0zM11.832 6.555a1 1 0 0 0-1.664-1.11zM7 12l-.832-.555A1 1 0 0 0 7 13zm6 0 .832.555A1 1 0 0 0 13 11zm-4.832 5.445a1 1 0 0 0 1.664 1.11zM5 17H3v2h2zm-2 0a1 1 0 0 1-.707-.293L.879 18.121A3 3 0 0 0 3 19zm-.707-.293A1 1 0 0 1 2 16H0a3 3 0 0 0 .879 2.121zM2 16V8H0v8zm0-8a1 1 0 0 1 .293-.707L.879 5.879A3 3 0 0 0 0 8zm.293-.707A1 1 0 0 1 3 7V5a3 3 0 0 0-2.121.879zM3 7h3.19V5H3zm12 0h2V5h-2zm2 0a1 1 0 0 1 .707.293l1.414-1.414A3 3 0 0 0 17 5zm.707.293A1 1 0 0 1 18 8h2a3 3 0 0 0-.879-2.121zM18 8v8h2V8zm0 8a1 1 0 0 1-.293.707l1.414 1.414A3 3 0 0 0 20 16zm-.293.707A1 1 0 0 1 17 17v2a3 3 0 0 0 2.121-.879zM17 17h-3.19v2H17zm7-4v-2h-2v2zM10.168 5.445l-4 6 1.664 1.11 4-6zM7 13h6v-2H7zm5.168-1.555-4 6 1.664 1.11 4-6z"
    />
  </svg>
);
export default SvgBatteryCharging;
